/**
 * Pure decisions behind the campaign-queue poll, kept free of React so they can be
 * tested directly.
 */

/**
 * Whether a waiting tab should schedule its next poll of the campaign queue.
 *
 * The waiting poll is the tab's heartbeat: stop polling and its place is given away
 * after ~15 s. `waiting` must therefore be the *current* answer to "is this tab
 * waiting?". Read from a React state value captured in an older render, it is still
 * `false` on the first poll of a wait — the state update that set it has not rendered
 * yet — and the poll never reschedules. That is the bug `CAMPAIGN_LANE_POLL_FIX` fixes,
 * by reading it from a ref that is set synchronously instead.
 */
export function shouldScheduleNextPoll({ schedule, waiting }) {
  return Boolean(schedule) && Boolean(waiting);
}

/**
 * Which "waiting" value the poll should trust.
 *
 * `pollFix` off keeps the original behaviour byte-for-byte (the captured state value);
 * on, it uses the ref, which is always current.
 */
export function effectiveWaiting({ pollFix, stateValue, refValue }) {
  return pollFix ? Boolean(refValue) : Boolean(stateValue);
}
